import { render, staticRenderFns } from "./RequestForm.vue?vue&type=template&id=bdd74f2c&scoped=true"
import script from "./RequestForm.vue?vue&type=script&lang=js"
export * from "./RequestForm.vue?vue&type=script&lang=js"
import style0 from "./RequestForm.vue?vue&type=style&index=0&id=bdd74f2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd74f2c",
  null
  
)

export default component.exports